module.exports = __webpack_public_path__ + "static/media/banner-novo-robo-lances.1d82235d.jpg";